import type { NodeEntry } from 'slate';

import type { RenderTextOptions } from './text';
import { renderText } from './text';
import { Queries } from '../../slate-api';
import type { RenderModelElement, RenderModelText } from '../../slate-api';
import type { RenderContext } from '../engine/render-context';

export function renderInvisible(
  renderContext: RenderContext,
  rMNodeEntry: NodeEntry<Extract<RenderModelElement, { children: RenderModelText[] }>>,
  options: RenderTextOptions
) {
  const { editor } = renderContext;

  renderContext.renderChildren(
    rMNodeEntry,
    { text: renderText },
    {
      ...options,
      inlineVoid: {
        caret: 'start',
        overrideWidthPx: Queries.getRMNodeWidthPx(editor, rMNodeEntry),
      },
    }
  );
}
